<div fxLayout="column">
  <div fxLayout="row">
    <label fxFlex="100">
      <h2>Δημιουργία πεδίου φόρμας</h2>
    </label>
    <mat-icon (click)="close()">close</mat-icon>
  </div>

  <div fxLayout="row" fxLayoutGap="10px">
    <mat-form-field>
      <input type="text" [(ngModel)]="field.title" matInput  placeholder="Field Name">
    </mat-form-field>
    <mat-form-field>
      <input type="text" [(ngModel)]="field.value" matInput  placeholder="Field Value">
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="10px">
    <div class="alignment-controls">
      <label>Τύπος πεδίου: &nbsp;</label>
      <mat-form-field>
        <mat-select  [(ngModel)]="field.type">
          <mat-option *ngFor="let type of types" [value]="type">{{type}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

  <div class="alignment-controls">
    <label>Στοίχιση πεδίου: &nbsp;</label>
    <mat-form-field>
      <mat-select [(ngModel)]="field.alignment">
        <mat-option *ngFor="let option of alignments" [value]="option">{{option}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  </div>

  <div fxLayout="row">
    <button mat-flat-button (click)="create()">Δημιουργία</button>
  </div>
</div>
